export const klaIcons = {
    "kla-icon-bucket": { content: 'e800' }, /* '' */
    "kla-icon-buildings": { content: 'e801' }, /* '' */
    "kla-icon-buoy": { content: 'e802' }, /* '' */
    "kla-icon-bus": { content: 'e803' }, /* '' */
    "kla-icon-businessman": { content: 'e804' }, /* '' */
    "kla-icon-calendar": { content: 'e805' }, /* '' */
    "kla-icon-camera": { content: 'e806' }, /* '' */
    "kla-icon-car": { content: 'e807' }, /* '' */
    "kla-icon-cash": { content: 'e808' }, /* '' */
    "kla-icon-city": { content: 'e809' }, /* '' */
    "kla-icon-close": { content: 'e80a' }, /* '' */
    "kla-icon-cloud": { content: 'e80b' }, /* '' */
    "kla-icon-comment": { content: 'e80c' }, /* '' */
    "kla-icon-commercialbuilding": { content: 'e80d' }, /* '' */
    "kla-icon-computer": { content: 'e80e' }, /* '' */
    "kla-icon-constructionworker": { content: 'e80f' }, /* '' */
    "kla-icon-creditcard": { content: 'e810' }, /* '' */
    "kla-icon-dam": { content: 'e811' }, /* '' */
    "kla-icon-design": { content: 'e812' }, /* '' */
    "kla-icon-doctor": { content: 'e813' }, /* '' */
    "kla-icon-donutgraph": { content: 'e814' }, /* '' */
    "kla-icon-ecoenergy": { content: 'e815' }, /* '' */
    "kla-icon-egg": { content: 'e816' }, /* '' */
    "kla-icon-electriccar": { content: 'e817' }, /* '' */
    "kla-icon-electricityoutlet": { content: 'e818' }, /* '' */
    "kla-icon-electricpole": { content: 'e819' }, /* '' */
    "kla-icon-eye": { content: 'e81a' }, /* '' */
    "kla-icon-farmer": { content: 'e81b' }, /* '' */
    "kla-icon-faucet": { content: 'e81c' }, /* '' */
    "kla-icon-fish": { content: 'e81d' }, /* '' */
    "kla-icon-flag": { content: 'e81e' }, /* '' */
    "kla-icon-flame": { content: 'e81f' }, /* '' */
    "kla-icon-footprint": { content: 'e820' }, /* '' */
    "kla-icon-forest": { content: 'e821' }, /* '' */
    "kla-icon-funnel": { content: 'e822' }, /* '' */
    "kla-icon-gardening": { content: 'e824' }, /* '' */
    "kla-icon-gasstation": { content: 'e825' }, /* '' */
    "kla-icon-gauge": { content: 'e826' }, /* '' */
    "kla-icon-globe": { content: 'e827' }, /* '' */
    "kla-icon-graph": { content: 'e828' }, /* '' */
    "kla-icon-hammer": { content: 'e829' }, /* '' */
    "kla-icon-hand": { content: 'e82a' }, /* '' */
    "kla-icon-hospitalcross": { content: 'e82b' }, /* '' */
    "kla-icon-hourglass": { content: 'e82c' }, /* '' */
    "kla-icon-house": { content: 'e82d' }, /* '' */
    "kla-icon-keys": { content: 'e82e' }, /* '' */
    "kla-icon-laptop": { content: 'e82f' }, /* '' */
    "kla-icon-leaf": { content: 'e830' }, /* '' */
    "kla-icon-library": { content: 'e831' }, /* '' */
    "kla-icon-lighthouse": { content: 'e832' }, /* '' */
    "kla-icon-lightningbolt": { content: 'e833' }, /* '' */
    "kla-icon-linegraph": { content: 'e834' }, /* '' */
    "kla-icon-lock": { content: 'e835' }, /* '' */
    "kla-icon-man": { content: 'e836' }, /* '' */
    "kla-icon-megaphone": { content: 'e837' }, /* '' */
    "kla-icon-moon": { content: 'e839' }, /* '' */
    "kla-icon-multiunitbuilding": { content: 'e83a' }, /* '' */
    "kla-icon-network": { content: 'e83b' }, /* '' */
    "kla-icon-newspaper": { content: 'e83c' }, /* '' */
    "kla-icon-oilcan": { content: 'e83d' }, /* '' */
    "kla-icon-park": { content: 'e83e' }, /* '' */
    "kla-icon-parkingmeter": { content: 'e83f' }, /* '' */
    "kla-icon-pause": { content: 'e840' }, /* '' */
    "kla-icon-pepper": { content: 'e841' }, /* '' */
    "kla-icon-phone": { content: 'e842' }, /* '' */
    "kla-icon-play": { content: 'e843' }, /* '' */
    "kla-icon-plug": { content: 'e844' }, /* '' */
    "kla-icon-policeofficer": { content: 'e845' }, /* '' */
    "kla-icon-powerbutton": { content: 'e846' }, /* '' */
    "kla-icon-recyclebin": { content: 'e847' }, /* '' */
    "kla-icon-recycling": { content: 'e848' }, /* '' */
    "kla-icon-recyclingbin": { content: 'e849' }, /* '' */
    "kla-icon-scale": { content: 'e84a' }, /* '' */
    "kla-icon-search": { content: 'e84b' }, /* '' */
    "kla-icon-shield": { content: 'e84c' }, /* '' */
    "kla-icon-signaltower": { content: 'e84d' }, /* '' */
    "kla-icon-smallarrow": { content: 'e84e' }, /* '' */
    "kla-icon-solarpanel": { content: 'e84f' }, /* '' */
    "kla-icon-student": { content: 'e850' }, /* '' */
    "kla-icon-sun": { content: 'e851' }, /* '' */
    "kla-icon-switch": { content: 'e852' }, /* '' */
    "kla-icon-synchronize": { content: 'e853' }, /* '' */
    "kla-icon-tablet": { content: 'e854' }, /* '' */
    "kla-icon-television": { content: 'e855' }, /* '' */
    "kla-icon-thermometer": { content: 'e856' }, /* '' */
    "kla-icon-trafficcone": { content: 'e857' }, /* '' */
    "kla-icon-train": { content: 'e858' }, /* '' */
    "kla-icon-tree": { content: 'e859' }, /* '' */
    "kla-icon-trophy": { content: 'e85a' }, /* '' */
    "kla-icon-truck": { content: 'e85b' }, /* '' */
    "kla-icon-video": { content: 'e85c' }, /* '' */
    "kla-icon-waterdrop": { content: 'e85d' }, /* '' */
    "kla-icon-waterlevel": { content: 'e85e' }, /* '' */
    "kla-icon-watertower": { content: 'e85f' }, /* '' */
    "kla-icon-weight": { content: 'e860' }, /* '' */
    "kla-icon-windturbine": { content: 'e861' }, /* '' */
    "kla-icon-woman": { content: 'e862' }, /* '' */
    "kla-lightbulb": { content: 'e863' }, /* '' */
    "kla-mobilephone-portrait": { content: 'e864' }, /* '' */
    "kla-watertower": { content: 'e865' }, /* '' */
    "kla-icon-accessibility": { content: 'e866' }, /* '' */
    "kla-icon-acorn": { content: 'e867' }, /* '' */
    "kla-icon-airballoon": { content: 'e868' }, /* '' */
    "kla-icon-airplane": { content: 'e869' }, /* '' */
    "kla-icon-anchor": { content: 'e86a' }, /* '' */
    "kla-icon-apple": { content: 'e86b' }, /* '' */
    "kla-icon-arrow": { content: 'e86c' }, /* '' */
    "kla-icon-banana": { content: 'e86d' }, /* '' */
    "kla-icon-bargraph": { content: 'e86e' }, /* '' */
    "kla-icon-barn": { content: 'e86f' }, /* '' */
    "kla-icon-battery": { content: 'e870' }, /* '' */
    "kla-icon-batteryeco": { content: 'e871' }, /* '' */
    "kla-icon-beaker": { content: 'e872' }, /* '' */
    "kla-icon-bicycle": { content: 'e873' }, /* '' */
    "kla-icon-bikehelmet": { content: 'e874' }, /* '' */
    "kla-icon-bikelock": { content: 'e875' }, /* '' */
    "kla-icon-binoculars": { content: 'e876' }, /* '' */
    "kla-icon-blueprint": { content: 'e877' }, /* '' */
    "kla-icon-boat": { content: 'e878' }, /* '' */
    "kla-icon-book": { content: 'e879' }, /* '' */
    "kla-icon-bridge": { content: 'e87a' }, /* '' */
    "kla-icon-broccoli": { content: 'e87b' } /* '' */
};
